import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Rubber Stamp.svg",
  "use": "Rubber Stamp.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Rubber Stamp.svg\"><path d=\"M52,48H12a2,2,0,0,1-2-2V38a2,2,0,0,1,2-2H28c0-11.99-4-14.029-4-20a8,8,0,0,1,16,0c0,5.971-4,8.01-4,20H52a2,2,0,0,1,2,2v8A2,2,0,0,1,52,48ZM16,50H48a2,2,0,0,1,0,4H16a2,2,0,1,1,0-4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol